export var EXPERIENCE_NAME_PREFIX = 'embedded-confluence/';
export var ExperienceNames = /*#__PURE__*/function (ExperienceNames) {
  ExperienceNames["VIEW_PAGE"] = "embedded-confluence/view-page";
  ExperienceNames["CC_VIEW_PAGE"] = "view-page";
  ExperienceNames["EDIT_PAGE"] = "embedded-confluence/edit-page";
  ExperienceNames["CC_EDIT_PAGE_EMBED"] = "edit-page-embed";
  ExperienceNames["WHITEBOARD"] = "embedded-confluence/whiteboard";
  ExperienceNames["CC_WHITEBOARD"] = "whiteboard-page";
  ExperienceNames["LOGIN_PAGE"] = "embedded-confluence/login-page";
  ExperienceNames["STORAGE_ACCESS_PAGE"] = "embedded-confluence/storage-access-page";
  ExperienceNames["PAGE_NOT_FOUND"] = "not-found";
  return ExperienceNames;
}({});
export var ExperienceReasons = /*#__PURE__*/function (ExperienceReasons) {
  ExperienceReasons["UNABLE_TO_DISPLAY_CONTENT"] = "Unable to display page content";
  ExperienceReasons["STORAGE_ACCESS_ERROR"] = "Error when obtaining Storage access";
  ExperienceReasons["STORAGE_ACCESS_NOT_SUPPORTED"] = "Storage access API is not supported";
  ExperienceReasons["STORAGE_ACCESS_REJECTED"] = "Storage access is rejected";
  return ExperienceReasons;
}({});

// Currently this is used only for embedded content modal / panel. Eventually this list should contains only all the events
// that Embedded Confluence supports so that we have contract which Confluence event that parent product can listen to.
export var SupportedExperienceNames = /*#__PURE__*/function (SupportedExperienceNames) {
  SupportedExperienceNames["ADD_COMMENT"] = "add-page-comment";
  SupportedExperienceNames["DELETE_COMMENT"] = "delete-page-comment";
  SupportedExperienceNames["DELETE_PAGE"] = "delete-page";
  SupportedExperienceNames["DELETE_DRAFT"] = "edit-page/revert-draft";
  SupportedExperienceNames["EDIT_CLOSE"] = "edit-page/close";
  SupportedExperienceNames["EDIT_LOAD"] = "edit-page/load";
  SupportedExperienceNames["EDIT_PAGE_EMBED"] = "embedded-confluence/edit-page";
  SupportedExperienceNames["EDIT_PUBLISH"] = "edit-page/publish";
  SupportedExperienceNames["LOGIN_PAGE"] = "embedded-confluence/login-page";
  SupportedExperienceNames["STORAGE_ACCESS_PAGE"] = "embedded-confluence/storage-access-page";
  SupportedExperienceNames["VIEW_CONTENT"] = "view-content";
  SupportedExperienceNames["VIEW_EDIT"] = "view-page/edit";
  SupportedExperienceNames["VIEW_PAGE"] = "embedded-confluence/view-page";
  return SupportedExperienceNames;
}({});